import { useCallback, useEffect, useState } from "react";
import AdminStatePanel from "../../layout/AdminStatePanel";
import { fetchAdminWeatherAlertEvents } from "../../../../../weather/weatherAlertAdminApi";

function formatValue(value) {
  if (value == null || value === "") {
    return "—";
  }
  return String(value);
}

const WeatherAlertEvidencePanel = ({ canManage }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadEvents = useCallback(async () => {
    if (!canManage) {
      return;
    }

    setLoading(true);
    setError("");

    try {
      const payload = await fetchAdminWeatherAlertEvents({ limit: 25 });
      setEvents(payload?.events || []);
    } catch (err) {
      setError(err.message || "Failed to load weather alert events.");
    } finally {
      setLoading(false);
    }
  }, [canManage]);

  useEffect(() => {
    loadEvents();
  }, [loadEvents]);

  if (!canManage) {
    return null;
  }

  return (
    <div className="admin-dash__card admin-dash__card--wide panel-card">
      <div className="admin-section-title-row">
        <h2 className="admin-section-title">Saved-location alert evidence</h2>
        <button
          type="button"
          className="admin-dashboard__action-btn admin-dashboard__action-btn--compact"
          onClick={loadEvents}
          disabled={loading}
        >
          Refresh
        </button>
      </div>
      <p className="muted">
        Radar context is supporting evidence only. Check role to see whether radar influenced the
        trigger or was attached as context.
      </p>

      {loading ? <AdminStatePanel variant="loading" message="Loading alert events…" /> : null}
      {!loading && error ? <AdminStatePanel variant="error" message={error} onRetry={loadEvents} /> : null}
      {!loading && !error && events.length === 0 ? (
        <p className="muted">No recent saved-location alert events.</p>
      ) : null}

      {!loading && !error && events.length > 0 ? (
        <div className="weather-alert-evidence-table-wrap">
          <table className="admin-table weather-alert-evidence-table">
            <thead>
              <tr>
                <th>Triggered</th>
                <th>Type</th>
                <th>Title</th>
                <th>Radar role</th>
                <th>Radar source</th>
                <th>Frame age</th>
                <th>Coverage</th>
                <th>Fallback</th>
              </tr>
            </thead>
            <tbody>
              {events.map((event) => {
                const radar = event.evidence?.radarContext;
                const admin = event.evidence?.radarContextAdmin;

                return (
                  <tr key={event.id}>
                    <td>{new Date(event.triggeredAt).toLocaleString()}</td>
                    <td>{event.eventType}</td>
                    <td>{event.title}</td>
                    <td>{formatValue(event.evidence?.radarContextRole)}</td>
                    <td>
                      {formatValue(radar?.sourceLabel || admin?.renderedSource)}
                      {radar?.trustLabel ? ` · ${radar.trustLabel}` : ""}
                    </td>
                    <td>
                      {radar?.frameAgeMinutes != null
                        ? `${radar.frameAgeMinutes} min`
                        : "—"}
                    </td>
                    <td>{formatValue(radar?.coverageStatus || admin?.evidence?.coverageStatus)}</td>
                    <td>
                      {radar?.fallbackActive
                        ? formatValue(radar?.fallbackReasonLabel || admin?.fallbackReason)
                        : "—"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

export default WeatherAlertEvidencePanel;
